import clsx from 'clsx';

import type { DescriptionBoxProps } from './types';

const DEFAULT_BACKGROUND = 'bg-white';
const DEFAULT_TEXT_COLOR = 'text-prompt-safecomoutrageous-orange';

export function DescriptionBox({
  text,
  backgroundColor = DEFAULT_BACKGROUND,
  textColor = DEFAULT_TEXT_COLOR,
  className,
}: DescriptionBoxProps) {
  return (
    <div
      className={clsx(
        'mb-3 w-full rounded-lg border border-input p-3 text-sm font-medium',
        backgroundColor,
        textColor,
        className,
      )}
    >
      {text}
    </div>
  );
}
